import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1e593295")

_pushScopeId("data-v-1e593295")
const _hoisted_1 = {
  class: "container popup-container",
  id: "edit-long-desciption"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row edit-row" }
const _hoisted_4 = { class: "editing-title" }
const _hoisted_5 = { class: "row edit-row" }
const _hoisted_6 = { class: "editing-wrapper" }
const _hoisted_7 = {
  class: "col-12",
  style: {"margin-block":"12px"}
}
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "faqQuestion" }
const _hoisted_10 = { class: "text-r" }
const _hoisted_11 = { class: "text-area-length" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("/150")
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "faqQuestion" }
const _hoisted_15 = { class: "text-r" }
const _hoisted_16 = { class: "text-area-length" }
const _hoisted_17 = { class: "row edit-row" }
const _hoisted_18 = { class: "col-12 px-0" }
const _hoisted_19 = { class: "col-12 px-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("p", null, _toDisplayString($props.type == 'faq' ? _ctx.$t('product.faq') : _ctx.$t('product.moreInfo')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.translations, (translateItem, index) => {
            return (_openBlock(), _createBlock(_Fragment, { key: index }, [
              (translateItem.languageId == $setup.selectedOption)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("div", _hoisted_7, [
                      _createVNode(_component_Multiselect, {
                        label: "name",
                        modelValue: $setup.selectedOption,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.selectedOption = $event)),
                        options: $setup.langs,
                        canDeselect: false,
                        valueProp: "id",
                        searchable: false
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_8, [
                        ($props.type == 'faq' || $setup.itemInfoType == $setup.productInfoType.Custom)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _createVNode("span", _hoisted_9, _toDisplayString($props.type != 'faq' ? _ctx.$t('product.moreAboutProduct.title') : _ctx.$t('faq.question.title')), 1),
                              _withDirectives(_createVNode("input", {
                                required: "",
                                type: "text",
                                maxlength: "150",
                                class: "bookit-input product-input form-control h48",
                                "onUpdate:modelValue": ($event: any) => (translateItem.name = $event)
                              }, null, 8, ["onUpdate:modelValue"]), [
                                [_vModelText, translateItem.name]
                              ]),
                              _createVNode("div", _hoisted_10, [
                                _createVNode("span", _hoisted_11, [
                                  _createVNode("span", {
                                    class: { 'length-limit': translateItem.name.length > 149 }
                                  }, _toDisplayString(translateItem.name.length || 0), 3),
                                  _hoisted_12
                                ])
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("div", _hoisted_13, [
                        _createVNode("span", _hoisted_14, _toDisplayString($props.type != 'faq' ? _ctx.$t('product.moreAboutProduct.description') : _ctx.$t('faq.answer.title')), 1),
                        _withDirectives(_createVNode("textarea", {
                          name: "",
                          id: "description",
                          cols: "30",
                          rows: "5",
                          class: "bookit-textarea product-textarea resize-off description",
                          maxlength: $setup.discMaxLength,
                          "onUpdate:modelValue": ($event: any) => (translateItem.description = $event)
                        }, "\n                                    ", 8, ["maxlength", "onUpdate:modelValue"]), [
                          [_vModelText, translateItem.description]
                        ]),
                        _createVNode("div", _hoisted_15, [
                          _createVNode("span", _hoisted_16, [
                            _createVNode("span", {
                              class: { 'length-limit': translateItem.description.length > ($setup.discMaxLength - 1) }
                            }, _toDisplayString(translateItem.description.length), 3),
                            _createTextVNode("/" + _toDisplayString($setup.discMaxLength), 1)
                          ])
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _createVNode("button", {
            class: "save-button-wrapper popup-bookit-button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args))),
            type: "button"
          }, _toDisplayString(_ctx.$t('button.save')), 1)
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("button", {
            class: "close-button-wrapper popup-bookit-button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args))),
            type: "button"
          }, _toDisplayString(_ctx.$t('button.close')), 1)
        ])
      ])
    ])
  ]))
})